export default __webpack_public_path__ + "static/media/hbanner.7d9a0128.jpeg";